/**
 * pre-signed URL(`/common/files/pre-signed-url`) 업로드 관련 유틸
 *
 * - 서버가 허용하는 확장자: pdf, jpg, jpeg, png, gif, zip (그 외는 발급 요청에서 400)
 * - S3 PUT 시 Content-Type은 서버가 확장자로 정한 값과 정확히 같아야 한다.
 *   (서명에 포함되므로 다르면 403 SignatureDoesNotMatch)
 */
export const ALLOWED_UPLOAD_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'zip'] as const;

const CONTENT_TYPE_BY_EXTENSION: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  pdf: 'application/pdf',
  zip: 'application/zip'
};

export const getFileExtension = (fileName: string): string => {
  const extension = fileName?.split('.').pop() ?? '';
  return extension === fileName ? '' : extension.toLowerCase();
};

/** 서버가 확장자로 판단하는 Content-Type과 동일한 값 (그 외는 application/octet-stream) */
export const getUploadContentType = (fileName: string): string =>
  CONTENT_TYPE_BY_EXTENSION[getFileExtension(fileName)] ?? 'application/octet-stream';

/** pre-signed URL 발급이 가능한 확장자인지 */
export const isAllowedUploadFileName = (fileName: string): boolean =>
  (ALLOWED_UPLOAD_EXTENSIONS as readonly string[]).includes(getFileExtension(fileName));

/** 이미지 업로드 input accept 값 (서버 허용 확장자 중 이미지) */
export const UPLOAD_IMAGE_ACCEPT = '.jpg,.jpeg,.png,.gif';
